import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { restApi } from '../../services/Api'
import { query, paginate } from '../../lib/loopback'
import { path } from 'ramda'
import { getOnlyDigits } from '../../utils/Utils'

const riscoRepository = createRepository({
  path: 'riscos',
  restApi,
  queryTransform: {
    numero: query.likeDigits('numero'),
    descricao: query.ilikeWithoutSplit('descricao'),
    ...paginate
  },
  getErrorMessage: response => path(['data', 'error', 'message'], response)
})

riscoRepository.listCustomer = ({ value, order, limit }) => {
  const descricao = {
    like: `%${value}%`
  }

  const where = Number(value)
    ? {
        or: [{ numero: getOnlyDigits(value) }, { descricao }]
      }
    : { descricao }

  const filter = {
    where,
    order,
    limit
  }

  return restApi.get('riscos', { filter })
}

export { riscoRepository }
